export const LOADER = 'LOADER';
